import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  loading: false,
  resetPasswordSuccess: false,
  confirmResetPasswordSuccess: false,
  error: null,
};

const slice = createSlice({
  name: 'resetPassword',
  initialState: initialState,
  reducers: {
    resetPasswordAction: (state, action) => {
      state.loading = true;
      state.error = null;
      state.resetPasswordSuccess = false;
    },
    confirmResetPasswordAction: (state, action) => {
      state.loading = true;
      state.error = null;
      state.confirmResetPasswordSuccess = false;
    },
    confirmResetPasswordSuccessAction: state => {
      state.loading = false;
      state.error = null;
      state.confirmResetPasswordSuccess = true;
    },
    resetPasswordSuccessAction: state => {
      state.loading = false;
      state.error = null;
      state.resetPasswordSuccess = true;
    },
    resetPasswordErrorAction: (state, action) => {
      state.loading = false;
      state.resetPasswordSuccess = false;
      state.error = action.payload;
    },
    resetPasswordResetState: () => initialState,
  },
});

export const {
  resetPasswordAction,
  resetPasswordSuccessAction,
  confirmResetPasswordAction,
  confirmResetPasswordSuccessAction,
  resetPasswordErrorAction,
  resetPasswordResetState,
} = slice.actions;

export default slice.reducer;
